query AnalyticsDurationByDate($filter: AnalyticsViewsFilterInput!, $calendarInterval: CalendarInterval) {
  analyticsViews(filter: $filter) {
    durationByDate(calendarInterval: $calendarInterval) {
      calendarInterval
      items {
        label
        displayCurrency
        data {
          x
          y
        }
      }
    }
  }
}
